export const selectedDaySelector = (
  { sessionData: { selectedDay } },
  patientProviderId
) => selectedDay[patientProviderId];
